import Vue from "vue";
import PostService from "@/services/PostService";
import { SET_LANGUAGE_VLOG, SET_LIST_LANGUAGE } from "../mutation-types";
const localState = () => ({
  postTypes: [
    {
      id: 2,
      name: `Vlog`,
    },
    {
      id: 3,
      name: `Coaching`,
    },
  ],
  golfVlogLanguage: [
    {
      id: "all",
      name: Vue.prototype.$gettext("All Language"),
    },
  ],
  languageDefaultVlog: "all",
  currentPost: {},
});

const mutations = {
  SET_FEEDS(state, data) {
    state.feeds = data;
  },
  [SET_LANGUAGE_VLOG](state, value) {
    state.languageDefaultVlog = value;
  },
  [SET_LIST_LANGUAGE](state, listData) {
    let newList = [];
    (state.golfVlogLanguage = [
      {
        id: "all",
        name: Vue.prototype.$gettext("All Language"),
      },
    ]),
      (newList = state.golfVlogLanguage.concat(listData));
    state.golfVlogLanguage = newList.sort((a,b) => (b.count > a.count) ? 1 : ((a.count > b.count) ? -1 : 0));

  },
};

const actions = {
  async newPost({ commit }, data) {
    return await PostService.newPost(data);
  },
  async updatePost({ commit }, data) {
    return await PostService.updatePost(data);
  },
  async deletePost({ commit }, key) {
    return await PostService.deletePost(key);
  },
  async newComment({}, data) {
    return await PostService.newComment(data);
  },
  async getMyPost({ rootState }, data) {
    let { page, limit } = data;
    return await PostService.getPostList({
      filter_profile: rootState.auth.user.profile,
      filter_type: [1, 2, 3],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getUserPost({}, data) {
    let { page, limit, user } = data;
    console.log(user);
    return await PostService.getPostList({
      filter_profile: user,
      filter_type: [1, 2, 3],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getAllPost({ rootState }, data) {
    let { page, limit, except_id } = data;
    return await PostService.getPostList({
      filter_type: [1, 2, 3],
      sort_desc: "createdDate",
      except_id: except_id,
      page: page,
      limit
    });
  },
  async getSubscriptions({ rootState }, data) {
    let { page, limit } = data;
    return await PostService.getPostListSubscriptions({
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getLanguagePost({ state, rootState }, type) {
    return await PostService.getPostListLanguage({
      filter_course: rootState.golfcourse.courseDetail.id || '',
      distinct_relation: "language",
      sort_desc: "createdDate",
      filter_type: type
    });
  },
  async getGolfVlog({ state, rootState }, data) {
      return await PostService.getPostList({
        filter_course: rootState.golfcourse.courseDetail.id,
        filter_type: [2],
        filter_language:
          state.languageDefaultVlog === "all" ? "" : state.languageDefaultVlog,
        sort_desc: "createdDate",
        page: (data && data.page) || 1,
      });

  },
  async getPostCourse({ state, rootState }, data) {
    let { page, limit } = data;
    return await PostService.getPostList({
      filter_course: rootState.golfcourse.courseDetail.id,
      filter_type: [
        7,
      ],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getPostDiscussion({}, data) {
    let { page, limit } = data;
    return await PostService.getPostList({
      filter_type: [8],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getPostVlog({}, data) {
    let { id, page, limit } = data;
    return await PostService.getPostList({
      filter_course: id,
      filter_type: [2],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getPostCoach({}, data) {
    let { page, limit } = data;
    return await PostService.getPostList({
      filter_type: [3],
      sort_desc: "createdDate",
      page,
      limit,
    });
  },
  async getPostVlogAndCoach({ state }, data) {
    let { page, limit } = data;
    return await PostService.getPostList({
      filter_type: [2, 3],
      filter_language:
          state.languageDefaultVlog === "all" ? "" : state.languageDefaultVlog,
      sort_desc: "createdDate",
      page,
      limit,
    });
  },

  /**
   * like post
   */
  async setLike({ commit, state }, data) {
    let input = {
      entityId: data.entityId,
      entityName: data.entityName,
    };

    let res = await PostService.setLike(input);
    if (res.error) {
      return res.error.message;
    } else {
      return;
    }
  },
  async setUnLike({ commit, state }, data) {
    let input = {
      entityId: data.entityId,
      entityName: data.entityName,
    };
    let res = await PostService.setUnLike(input);

    if (res.error) {
      return res.error.message;
    } else {
      return;
    }
  },

  openEditPostForm({ state }, post) {
    const currentPost = JSON.parse(JSON.stringify(post));
    const photos = [];
    const youtubes = [];
    delete currentPost.profile;
    currentPost.media.forEach((media) => {
      if (media.type == 1) {
        photos.push({
          file: null,
          title: media.description,
          thumb: media.thumbnail,
          id: media.id,
        });
      }
      if (media.type == 2) {
        youtubes.push({
          id: media.id,
          youtubeId: media.youtubeId,
        });
      }
    });
    delete currentPost.media;
    currentPost.photos = photos;
    currentPost.youtubes = youtubes;
    state.currentPost = currentPost;
  },
};

export default {
  namespaced: true,
  state: localState(),
  mutations,
  actions,
};
